export enum Languages {
    PL = 'pl',
    EN = 'en',
    UK = 'uk',
}

export enum RouterStep {
    Tickets = 'tickets',
    Upsell = 'upsell',
    Accommodation = 'accommodation',
    AccommodationDetails = 'accommodation_details',
    Order = 'order',
    ThankYou = 'thankyou',
}
